module.exports = __webpack_public_path__ + "gg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gg.svg
// module id = 564
// module chunks = 0